/**
 * Design tokens.
 *
 * `as const` keeps every value a literal type, so consumers get
 * `'#FF6B00'` rather than a widened `string`.
 */

export const ACCENT = '#FF6B00' as const;
export const ACCENT_HOVER = '#FF8E53' as const;
export const ACCENT_GLOW = 'rgba(255,107,0,0.5)' as const;

export const SURFACE = '#0A0A0A' as const;
export const SURFACE2 = '#050505' as const;
export const SURFACE_LIGHT = '#111111' as const;
export const SURFACE_ELEVATED = '#181818' as const;

export const BORDER = 'rgba(255,255,255,0.08)' as const;
export const BORDER_LIGHT = 'rgba(255,255,255,0.15)' as const;
export const BORDER_ACTIVE = 'rgba(255,107,0,0.35)' as const;

export const MUTED = '#666' as const;
export const TEXT_PRIMARY = '#F5F5F5' as const;
export const TEXT_SECONDARY = '#888' as const;

/** Font stacks. Kept as tokens so a family swap is a one-line change. */
export const FONT_DISPLAY = '"Bebas Neue", sans-serif' as const;
export const FONT_BODY = 'Inter, sans-serif' as const;
export const FONT_MONO = '"JetBrains Mono", monospace' as const;
export const FONT_ACCENT = '"Playfair Display", serif' as const;

/** Shared easing curve used across transitions and reveals. */
export const EASE = 'cubic-bezier(0.25,0.46,0.45,0.94)' as const;
/** Overshoot easing for spring-like pops (day chips, saved badges). */
export const EASE_SPRING = 'cubic-bezier(0.34,1.56,0.64,1)' as const;

/** Viewport width (px) at or below which the layout switches to mobile. */
export const MOBILE_BREAKPOINT = 768 as const;
